import classes from './MealsSummary.module.css';

const MealsSummary = () => {
  return (
    <section className={classes.summary}>
      <h2>Freshly prepared chops and fruits —</h2>
      <p>simple choices, made for your moment.</p>
      <p className={classes.supporting}>
        From quick bites to fresh fruits, there’s something for every mood —
        light, tasty, and always easy to enjoy.
      </p>
    </section>
  );
};

export default MealsSummary;
